import { render, staticRenderFns } from "./UsResList.vue?vue&type=template&id=02e1a1b6&scoped=true"
import script from "./UsResList.vue?vue&type=script&lang=js"
export * from "./UsResList.vue?vue&type=script&lang=js"
import style0 from "./UsResList.vue?vue&type=style&index=0&id=02e1a1b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e1a1b6",
  null
  
)

export default component.exports